export default __webpack_public_path__ + "static/media/submitted_review.991eeffd.svg";